import createCachedSelector from 're-reselect';

import getDocumentById from '../layers/getDocumentById';

const getTransformsById = createCachedSelector(
    [getDocumentById],
    (doc) => doc.transforms,
)((state, documentId) => documentId);

export default getTransformsById;
